module.exports = __webpack_public_path__ + "static/media/slide-6.47434ef0.webp";